// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_34AbcH","iconContainer":"_3ZqDhd","iconContainerVisited":"AX-E28","icon":"_1Oe10L","preTitle":"lyCKhi"};